import React from 'react'
import {Spin, Tooltip, message, Button,DatePicker } from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import PageCommon from  "@components/PageCommon/PageCommon";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import { Link } from "react-router-dom"
import Lang from "@components/Lang/Lang";
import TransferAction from "../Transfer.action";
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { toFixedWithCommas} from "@utils/number-util";
import OrderDetails from '../../../../components/ModalOrderDetails/OrderDetails';
import dayjs from 'dayjs';
import "./index.less"
/**
 * 调拨中 页签 | 使用统一的 查询表格组件
 *
 * @author FJJ
 * @version 2.0
 *
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version Zhaoruji  => 备份在 index.bak.js
 * 2023      2.0    FJJ
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class TransferringTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list:[],//行
            extra: {},
            selectOrder:{},
            // 搜索默认
            searchStatus:0,
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'toWarehouseId',
                    cnPlaceholder:'目的仓库',
                    cnPlaceholderId:'MuDiCangKu',
                    type:'SearchSelect',
                    searchClass:{
                        api:"/service/mg/allocate/warehouse-list",
                        nameField: 'transitCityName',
                        idField:'warehouseId',
                    },
                    width: 116,
                },
                {
                    name:'keyWord',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索PO单号或客户编号',
                    cnPlaceholderId:'SouSuoPODanHaoHuoKeHuBianHao',
                    width:256,
                },
            ],
            columns:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    dataIndex: 'buyerCode',
                    render:(text, record, index) => (
                       record.buyerId?<Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{text}</Link>:text
                    ),
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    width: 200,
                    cnTitleId: 'PODingDan',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}</p>
                        {record.poCode&&<LogisticsAndCabinetSwitch poId = {record.poId}
                            poCode={record.poCode}
                            containerCode={record.containerCode}
                            cabinetNum={record.cabinetNum}
                            logisticsData={record.pubOrderTrackVOS}
                        />}
                    </>)
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.totalSkuNum}{Lang({id:'Kuan', default:'款'})}，{record.totalQuantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },{
                    cnTitle: '总体积m³',
                    dataIndex: 'totalVolume',
                    cnTitleId: 'ZongTiJiM3',
                    render: (totalVolume, record) => <span className="content-text">{toFixedWithCommas(totalVolume, 3) || "-"}</span> //{" "}m³
                },
                {
                    cnTitle: '当前仓库',
                    cnTitleId: 'DangQianCangKu',
                    dataIndex: 'fromWarehouseName',
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'toWarehouseName',
                },
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    dataIndex: 'time',
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'ZhuangGuiFaYunShiJian', default: '装柜发运时间'})}>
                                <i className="ri-truck-line mr_6 black33"></i>{record.loadDate ? dayjs(record.loadDate).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>

                        <p>
                            <Tooltip placement="left" title={Lang({id: 'DiaoBoShiJian', default: '调拨时间'})}>
                                <i className="ri-share-forward-line mr_6 black45"></i>{record.allocateDate?dayjs(record.allocateDate).format('YYYY-MM-DD'):'-'}
                            </Tooltip>
                        </p>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'YuJiDaoGangShiJian', default: '预计到达时间'})}>
                                <i className="ri-map-pin-line mr_6 color-green"></i>{record.preIntoWarehouseDate?dayjs(record.preIntoWarehouseDate).format('YYYY-MM-DD'):'-'}
                            </Tooltip>
                        </p>
                   </> )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 60,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div >
                        <AuthBtn icon={"ri-article-line"} tips = {Lang({id:"XiangQing",default:"详情"})}
                                       onClick={()=>this.getDeliveryListInfo(record.poId)}/>
                    </div>)},
            ],
            showTip: false,// 批量提示出库提示
            showTimeTips:false,
        }
        this.intoWarehouseInfo = {}
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 获取单个出库详情*/
    getDeliveryListInfo(id) {
        this.loading(true)
        this.handleCloseDetails(true)
        TransferAction.postDeliveryListInfo({
            id,
        }).then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                let order = res.data.model || {}
                this.setState({
                    selectOrder: {
                        ...order,
                        ids: [order.id],
                    },
                    extra: res.data.extra,
                })
            } else {
                message.info(res.data.message);
            }
        })
    }
    handleCloseDetails(flag=false){
        this.setState({
            showDetails:flag
        })
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    // 查询回调
    fetchCallBack(res){
        this.onRefPageCommonChild.isShowTop()
        const {success,valid,models,extra} = res;
        if (success && valid) {
            this.setState({
                list: models
            })
            if(this.props.changeNum&&extra)this.props.changeNum(extra.waitAllocateCount,extra.allocatingCount)
        }else this.setState({
            list: []
        })
    }
    // 选择表格行
    setSelectedRowKeys(ids){
        this.setState({
            selectedRowKeys:ids
        })
    }
    onSelectChange = (newSelectedRowKeys) => {
        this.setSelectedRowKeys(newSelectedRowKeys);
    };
    // 打开 批量入库窗口
    onInStorage(type=""){
            const { selectedRowKeys,list } = this.state;
            if(selectedRowKeys&&selectedRowKeys.length>0){
                this.openBatchDelivery(true)
            }else message.warning(Lang({id:"QingXuanZeYaoCaoZuoDeShuJu",default:"请选择要操作的数据"}))

    }
    /**
     * 入库确认*/
   openBatchDelivery(flag=false){
        this.setState({
            showTip: flag,
        })
    }
    batchInStorage() {
       const { selectedRowKeys,inStorageTime } = this.state;
       if(inStorageTime){
           TransferAction.inStorage({
               ids: selectedRowKeys || [],
               inStorageTime:inStorageTime
           }).then(res => {
               if (res.data.success && res.data.valid) {
                   message.success(Lang({id:"RuKuChengGong",default:"入库成功"}));
                   this.onPageTemplateTableChild.handleFetch(1,{},true)
                   this.openBatchDelivery()
               } else if (!res.data.success) {
                   message.info(res.data.message);
               }

           })
       }else {
           this.setState({
               showTimeTips: true
           })
       }
    }
    // 批量 撤销调拨
    rollback(){
        const { selectedRowKeys,list } = this.state;
        if(selectedRowKeys&&selectedRowKeys.length>0){
            TransferAction.rollback({
                ids: selectedRowKeys || []
            }).then(res => {
                const data = res.data || {};
                const { success, valid, } = data;
                if (success && valid) {
                    message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
                    this.onPageTemplateTableChild.handleFetch(1,{},true)
                } else if (!success||!valid) {
                    if(data.message){
                        message.info(data.message);
                    }else message.warning(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
                }
            })
        }else message.warning(Lang({id:"QingXuanZeYaoCaoZuoDeShuJu",default:"请选择要操作的数据"}))
    }
    // 修改时间
     onChangeTime(value){
        this.setState({
            inStorageTime: value?dayjs(value).valueOf():"",
            showTimeTips: value?false:true
        })
     }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    render() {
        const {loading, columns,searchFormOptions, selectedRowKeys,showTip,showDetails, extra,selectOrder,showTimeTips} = this.state;
        return (<PageCommon  onRef={this.onRefPageCommon} className={"transferWrap"} btnList={[
                {
                    btn: Lang({id:"RuKu",default:"入库"}),
                    icon:"ri-calendar-check-line mr_4 color-blue",
                    btnClick:()=>this.onInStorage("batchDelivery")
                },{
                    btn: Lang({id:"CheXiaoDiaoBo",default:"撤销调拨"}),
                    icon:"ri-arrow-go-back-line color-red mr_4",
                    needConfirm: Lang({id:"QueDinCheXiaoDiaoBo",default:"确定撤销调拨"})+"？",
                    btnClick:()=>this.rollback()
                }
            ]}>
                 <AutoFetchTable columns={columns}
                                 onRef={this.onRefTabOne}
                                 // initFetch={false}
                                 fetchCallBack={(data)=>this.fetchCallBack(data)}
                                rowSelection={{
                                    selectedRowKeys,
                                    onChange: this.onSelectChange,
                                }}
                                flagShowReset={false}
                                precondition={{status:20}} // 10:待调拨列表 20:调拨中列表
                                pageSize={50}
                                searchFormOptions={searchFormOptions}
                                fetchApi={'/service/mg/allocate/list'}
                      />
                {/*出库详情弹窗*/}
                {showDetails&&<EssaModal title={Lang({id:"DingDanXiangQing",default:"订单详情"})}
                                        open={showDetails}
                                        width={750}
                                        onCancel={()=>this.handleCloseDetails()}
                                        footer={[
                                           <Button onClick={() => this.handleCloseDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>,
                                       ]}>
                    <Spin spinning={loading}>
                       {selectOrder&&selectOrder.orderNumber&&extra.currencySymbol&&<OrderDetails
                           data={selectOrder}  />}
                    </Spin>
                </EssaModal>}
                {showTip&&<EssaModal title={Lang({id:"QueRenDiaoBoRuKu",default:"确认调拨入库"})}
                                     open={showTip}
                                     width={420}
                                     onCancel={()=>this.openBatchDelivery(false)}
                                     onOk={()=>this.batchInStorage()}>
                    <div className={"transferWrapPop"}>
                        <p>
                            <span className={"color-red"}>*</span>
                            {Lang({id:"RuKuRiQi",default:"入库日期"})}
                        </p>
                        <DatePicker style={{width:"100%"}} showTime onChange={(date)=>this.onChangeTime(date)}/>
                        {showTimeTips&&<p className={"mt_8 color_red"}>
                            {Lang({id:"QingXuanZeRiQi",default:"请选择日期"})}
                        </p>}
                    </div>
                </EssaModal>}
            </PageCommon>
        )
    }
}